const OFFER_PAGE_ASSISTANT_SPOOF_AGENT_USER_IDS: ReadonlySet<string> = new Set([
  'cf01cdf4-1019-4641-bf97-843fcd8fae15', // William Ritossa
  '69fbdc21-93a5-47e3-b3c6-2355d47e363b', // Joss Paling
  '309bbbeb-24c1-4929-becd-4e5e67c2b1d9', // Sam Hammond
])

export function canAlwaysUseOfferPageAssistantInSpoofMode({
  isSpoofed,
  spoofingAgentUserId,
}: {
  isSpoofed: boolean
  spoofingAgentUserId?: string
}): boolean {
  return (
    isSpoofed &&
    !!spoofingAgentUserId &&
    OFFER_PAGE_ASSISTANT_SPOOF_AGENT_USER_IDS.has(spoofingAgentUserId)
  )
}
